"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Text = exports.TripleOption = exports.TripleWrapper = exports.DoubleOption = exports.DoubleWrapper = exports.Option = exports.Wrapper = void 0;
const building_blocks_ui_common_1 = require("@acko-tech/building-blocks.ui.common");
const building_blocks_ui_theme_1 = require("@acko-tech/building-blocks.ui.theme");
exports.Wrapper = building_blocks_ui_common_1.styled.div `
  min-width: 360px;
  display: flex;
  align-items: center;
  position: relative;
  background: ${building_blocks_ui_theme_1.AckoMainTheme.colors.light.primary.n0};
  flex-direction: column;
`;
exports.Option = building_blocks_ui_common_1.styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: ${building_blocks_ui_theme_1.AckoMainTheme.border.radius.large};
  width: ${(props) => props.width || '100%'};
  height: ${(props) => props.height || `${building_blocks_ui_common_1.$fontSize.xxxl}`};
  margin: ${(props) => props.margin || '8px 20px 8px 20px'};
  transition: 0.2s ease-in;
  cursor: pointer;
  background: ${(props) => props.isSelected
    ? 'rgba(15, 164, 87, 0.05)'
    : `${building_blocks_ui_theme_1.AckoMainTheme.colors.light.neutral.n100}`};
  border: ${(props) => props.isSelected
    ? `1px solid ${building_blocks_ui_theme_1.AckoMainTheme.colors.light.green.g300}`
    : '1px solid rgba(15, 164, 87, 0.05)'};
  &:hover,
  &.selected {
    background: rgba(15, 164, 87, 0.05);
    border: 1px solid ${building_blocks_ui_theme_1.AckoMainTheme.colors.light.green.g300};
  }
`;
exports.DoubleWrapper = building_blocks_ui_common_1.styled.div `
  min-width: 336px;
  margin: 0 ${building_blocks_ui_theme_1.AckoMainTheme.spacing[3]};
  display: grid;
  grid-gap: ${building_blocks_ui_theme_1.AckoMainTheme.spacing[4]};
  grid-template-columns: auto auto;
  background: ${building_blocks_ui_theme_1.AckoMainTheme.colors.light.primary.n0};
`;
exports.DoubleOption = (0, building_blocks_ui_common_1.styled)(exports.Option) `
  height: ${(props) => props.height || `${building_blocks_ui_common_1.$fontSize.xxxl}`};
  margin: ${(props) => props.margin || '8px 8px 8px 8px'};
`;
exports.TripleWrapper = (0, building_blocks_ui_common_1.styled)(exports.DoubleWrapper) `
  min-width: 332px;
  margin: 0 ${building_blocks_ui_theme_1.AckoMainTheme.spacing[4]};
`;
exports.TripleOption = (0, building_blocks_ui_common_1.styled)(exports.Option) `
  height: ${(props) => props.height || `${building_blocks_ui_common_1.$fontSize.xxxl}`};
  margin: ${(props) => props.margin || '8px 6px 8px 6px'};
`;
exports.Text = building_blocks_ui_common_1.styled.div `
  font-family: ${building_blocks_ui_theme_1.AckoMainTheme.typography.fonts.family.family};
  font-weight: ${building_blocks_ui_theme_1.AckoMainTheme.typography.fonts.weight.P1};
  font-size: ${building_blocks_ui_theme_1.AckoMainTheme.typography.fonts.size.P2};
  line-height: ${building_blocks_ui_theme_1.AckoMainTheme.typography.lineHeights.P2};
  text-align: center;
  color: ${building_blocks_ui_theme_1.AckoMainTheme.colors.light.primary.n600};
  margin: ${building_blocks_ui_theme_1.AckoMainTheme.spacing[3]};
`;
//# sourceMappingURL=selector-chips.style.js.map